import API from "../api";
import { TokenService } from "@/api/storage.js";
import { initialize, initializePersonalData } from "@/api";

export default {
  namespaced: true,
  state: {
    token: null,
    runRefresh: false,
    routeWithoutToken: null
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload;
    },
    setRunRefresh(state, payload) {
      state.runRefresh = payload;
    },
    setRouteWithoutToken(state, payload) {
      state.routeWithoutToken = payload;
    }
  },
  actions: {
    storeToken({ commit }, payload) {
      TokenService.removeToken();
      TokenService.saveToken(JSON.stringify(payload.access_token));
      TokenService.saveUserInfo(payload.user_info);
      if (payload.refresh_token) {
        TokenService.saveRefreshToken(JSON.stringify(payload.refresh_token));
      }
      initialize(payload.access_token);
      initializePersonalData(payload.access_token);
      commit("setToken", payload.access_token);
    },
    async loginUser({ dispatch }, payload) {
      const { data } = await API.getToken(payload);
      dispatch("storeToken", data);
      return data;
    },
    async guestLogin({ dispatch }, payload) {
      const { data } = await API.getGuestToken(payload);
      dispatch("storeToken", data);
      return data;
    },
    logout({ commit }) {
      commit("setRouteWithoutToken", null);
      commit("setRunRefresh", false);
      TokenService.removeToken();
      TokenService.removeRefreshToken();
    },
    async requestRefreshToken({ dispatch, commit }) {
      commit("setRunRefresh", true);
      const payload = {
        client_id: "2f4a6b98-5715-4b73-95ab-466d3350f32c",
        grant_type: "refresh_token",
        refresh_token: TokenService.getRefreshToken()
      };
      const { data } = await API.getToken(payload);
      dispatch("storeToken", data);
      commit("setRunRefresh", false);
      return data;
    },
    async requestForgotPassword(context, payload) {
      const { data } = await API.putForgotPassword(payload);
      return data;
    },
    async requestRecoverPassword(context, payload) {
      const { data } = await API.putRecoverPassword(payload);
      return data;
    },
    saveRouteWithoutToken({ commit }, payload) {
      commit("setRouteWithoutToken", payload);
    }
  },
  modules: {}
};
